// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"tO-z","carouselContainer":"uO-z"};